import axios from '../utils/axios';

const API_URL = process.env.REACT_APP_API_URL + '/v1/client/';

const confirmEmailVerification = (clinicId, code) => {
    return axios.post(API_URL + 'clinics/' + clinicId + '/verifications/confirm', { code });
};

const verificationService = {
    confirmEmailVerification,
};

export default verificationService;
